
export const environment = {
  production: false,
  base_url: 'https://portal.eeviction.com',
  api_prefix: 'https://api.eeviction.com/',
  waf_captcha: {
    // AWS WAF CAPTCHA integration (see .kiro/specs/waf-captcha-intake). Populate from the WAF
    // console "Application integration" after `aws wafv2 create-api-key`. Empty ⇒ disabled no-op.
    jsapiUrl: 'https://c2ae7cc8d3c7.us-east-1.captcha-sdk.awswaf.com/c2ae7cc8d3c7/jsapi.js',
    apiKey: 'Tb20pcRtIh6Qnmi/St077WsmYNLss85TFxz0aT6XwnMpA1IxWme5Jc7fKxsn41b1Hu0XT+8eb1UuvCeSdVTFCK9hkykFUX0H6dlZLh8/X0FkZKnGgQ9EtPDYVONi7oDCdotjp5glhHIQcgvYtTBN9+2X+T9HsanJL+67BBlHjNyvV5ErGH467ZqCWEYRKJxNn8nouGNthXQrdH7wwolJVTl6fFjjyKPYyLz34qpshbi1vTZT8HpOiog14uhqvB6OUH/YoB1qkUxQqDm21JUWbDdVQqZy3rcsEetNgPWNkSt7L+1eusPO2H+5bzpZBekRHK5aUcSj6QglJkkGTsdqqlHlDLBEQ1IIxOwW2HFhfP0Joz7fQfv+ukuKGw587bkCEbJXc1UlwnWmi38Fq9PElr0iHdpFMbiqRBs5C93fN3DYT1lWGnrsINHrPGgoxELKAwQtNWl1gv3xCxzxHgl3P0De/nIOL75y+MGBso+listmgTyrarfQBR4boiQX28HYlFZg/5sKMzwDc3UqFX7WG9+fJrt4201tOkg8ePITSSucFlAjaEy90rW4MhwfEtOeqOzddeBQvuvfy56tO3RnpH5LfzY9XvYGc+k7dmnXbIsKnjpnIbUDIsUO6GhzbZ05ZXIXnhJb7G3+U7s7P+yHN8ZkYrypF/FhJQqhzf6gRHI=_0_1'
  },
  version: 'a5b35c88a04c83ff0bb3b4f0e5361b089ac604fe',
  rum: {
    app_monitor_id: '31371ae2-ec0a-4290-812b-795fbe8b3abf',
    identity_pool_id: 'us-east-1:07230ef9-f3db-47c4-a3cf-a5a91b17413b',
    region: 'us-east-1',
    enable_xray: true,
    session_sample_rate: 1,
    signing: false,
    endpoint: 'https://rum.eeviction.com',
  },
  posthogKey: 'phc_zxju9AFDJ4tts5GXcvw79wVaNRWvTVJ8G7N7cYHL2E7v', // PostHog project 489074
  posthogHost: 'https://a.eeviction.com',
  posthogUiHost: 'https://us.posthog.com'
};
